import { Briefcase } from 'lucide-react';

import { ChannelSourcePage } from '../components/ChannelSourcePage';

export function UpworkAnalyticsPage() {
  return (
    <ChannelSourcePage
      source="upwork"
      title="Upwork"
      description="Lead inflow from Upwork. Profile analytics are added when the integration is connected."
      icon={Briefcase}
      integrationKey="upwork"
    />
  );
}
